const ReadPostsTracker = {
	storageKey: 'touchit_read_posts',

	init() {
		this.trackCurrentPost();
		this.applyReadClass();
		this.bindEvents();
	},

	bindEvents() {
		document.addEventListener('touchit:postsLoaded', () => {
			this.applyReadClass();
		});
	},

	getReadPosts() {
		try {
			const stored = localStorage.getItem(this.storageKey);
			return stored ? JSON.parse(stored) : [];
		} catch (e) {
			console.error('Error reading read posts from localStorage:', e);
			return [];
		}
	},

	saveReadPosts(posts) {
		try {
			localStorage.setItem(this.storageKey, JSON.stringify(posts));
		} catch (e) {
			console.error('Error saving read posts to localStorage:', e);
		}
	},

	markPostAsRead(postId) {
		if (!postId) return;

		const readPosts = this.getReadPosts();
		
		if (!readPosts.includes(postId)) {
			readPosts.push(postId);
			this.saveReadPosts(readPosts);
		}
	},

	applyReadClass() {
		const readPosts = this.getReadPosts();
		
		if (readPosts.length === 0) return;

		const articles = document.querySelectorAll('[data-post-id]');
		
		articles.forEach(article => {
			const postId = article.getAttribute('data-post-id');

			if (postId && readPosts.includes(postId)) {
				article.classList.add('read');
			}
		});
	},

	trackCurrentPost() {
		const body = document.body;

		if (body.classList.contains('single-post') || body.classList.contains('single')) {
			const postIdClass = Array.from(body.classList).find(cls => cls.startsWith('postid-'));
			
			if (postIdClass) {
				const postId = postIdClass.replace('postid-', '');
				this.markPostAsRead(postId);
			}
		}
	}
};

export default ReadPostsTracker;
